import type { Scenario } from "@/composables/forms/formTypes";
import type { Casings } from "gql/api";
import type { Maybe } from "graphql/jsutils/Maybe";

export function computeCasingLabel(
  casing: Maybe<Partial<Casings>>,
  metric?: boolean
): string {
  if (casing) {
    if (metric && casing.metric_name) {
      return `${casing.metric_name}, ${casing.imperial_name}`;
    }
    return `${casing.imperial_name}, ${casing.metric_name}`;
  }

  return "";
}
